import {Table, TableBody, TableCell, TableRow, Paper,TableHead} from "@mui/material";
import React from "react";
import {ChatdeskUpdatesRow} from "./Row";
import styles from "./Styles.module.css";

const ChatdeskUpdatesTable = ({data}) => {
    return (
        <div className="search-messages-table">
            <Paper className={styles.root}>
                <Table>
                    <TableHead>
                        <TableRow className={styles.tableRow}>
                            <TableCell>
                                <span className={styles.typography13}>Company</span>
                            </TableCell>
                            <TableCell>
                                <span className={styles.typography13}>Notification Date</span>
                            </TableCell>
                            <TableCell>
                                <span className={styles.typography13}>User</span>
                            </TableCell>
                            <TableCell >
                                <span className={styles.typography13} >Summary</span>
                            </TableCell>
                            <TableCell>
                                <span className={styles.typography13}>Status</span>
                            </TableCell>
                            <TableCell>
                                <span className={styles.typography13}>Link</span>
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {data && data.length === 0 &&
                            <TableRow className={styles.tableRow}>
                                <TableCell colSpan={4} className={styles.typography13}>There are no updates available</TableCell>
                            </TableRow>
                        }

                        {data.map(update => {
                            return <ChatdeskUpdatesRow
                                update={update}
                                key={update.id}
                            />
                        })}
                    </TableBody>
                </Table>
            </Paper>
        </div>
    )
}

export default ChatdeskUpdatesTable
